import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-lagerstamm-list-view',
  imports: [],
  templateUrl: './lagerstamm.list-view.html',
  styleUrls: ['./lagerstamm.list-view.css'],
})
export class LagerstammListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
